import { useQuery } from '@tanstack/react-query'
import { readSavedQueries, type SavedSearchConfig } from '@/lib/saved-search'

// 保存済み検索クエリの一覧を取得
export function useSavedSearchQueries(config: SavedSearchConfig) {
  return useQuery({
    queryKey: config.queryKey(),
    queryFn: () => {
      try {
        return readSavedQueries(config).sort((a, b) => b.createdAt - a.createdAt)
      } catch {
        // 要素が null などで並び替えが例外になる場合は空配列を返す
        return []
      }
    },
    staleTime: 0, // 常に最新を取得
  })
}
